module.exports = __webpack_public_path__ + "static/media/typo3.4241d049.svg";